export class BOMItem {
  public constructor(
    public id: string,
    public componentDescription: string,
    public itemCategory: string,
    public component: string,
    public weight: string,
    public unit: string,
    public sortString: string,
    public engineeringChangeOrderNumber?: string
  ) {}
}

export const bomItemIdKey: keyof BOMItem = 'id';
